import Vue from 'vue'

import { removeDuplicateTags, removeByKey  } from './helpers/vue_tools.js';


const app = new Vue({
    delimiters: ['${', '}'],
    data:{
        loaded: false,
        totalPagesLoaded: 1,
        totalPages: null,
        perPage: 200,
        today: new Date(),
        headers: {
            totalEntires: null,
            totalQueryPages: null,
        },
        settings:{
            sorted: null,
            query:{
                postType: 'masterclass',
                orderby: 'ASC',
            },
            labels:{}
        },
        filters:{
            sort_by:[],
            tags:[],
        },
        tags: {
            list: [],
            applied: [],
        },
        displayed_data: [],
        entries: [],

    },
    mounted: function(){
        const t = this;
        t.$data.url = window.location.href;

        t.queryTerms({});
        t.queryAPI({});
    },
    methods:{
        queryTerms: function( params ){
            const t = this;

            let fetchURL = "/wp-json/wp/v2/masterclass_tags?per_page=100";

            fetch( fetchURL ).then(function (response) {
                if(response.ok){
                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                for (var i = data.length - 1; i >= 0; i--) {

                   if (data[i].count > 0) {
                        t.$data.tags.list.push({
                            id: parseInt(data[i].id),
                            name: data[i].name
                        });
                    }
                };

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },
        queryAPI: function( params ){
            const t = this;

            let fetchURL = '/wp-json/wp/v2/'+t.$data.settings.query.postType+'/';
                fetchURL += '?per_page=100&page=' + t.$data.totalPagesLoaded;
                fetchURL += '&custom_order_by=' + t.$data.settings.query.orderby;

            fetch( fetchURL ).then(function (response) {
                if(response.ok){

                    response.headers.forEach( function(element, index) {
                        if(index==='x-wp-total'){
                            t.$data.headers.totalEntires = parseInt(element);
                        }

                        if(index==='x-wp-totalpages'){
                            t.$data.headers.totalQueryPages = parseInt(element);
                        }
                    });

                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {
                    t.$data.totalPages = t.$data.headers.totalEntires / t.$data.perPage;
                    t.parseData( data );

                    t.$data.loaded = true;

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },
        parseData: function( data ){
            const t = this;
            t.$data.entries = [];

            if(data.length ){
                for(let i = 0, length1 = data.length; i < length1; i++){

                    let entryData = {
                        index: i,
                        id: data[i].id,
                        post_date: data[i].date,
                        title: data[i].title.rendered,
                        slug: data[i].slug,
                        url: t.$data.url+data[i].slug,
                        featured_image: data[i].the_featured_image,
                        end_date: data[i].acf.masterclass_end_date,
                        isPast: (new Date() > new Date(data[i].acf.masterclass_end_date)),
                        season_label: data[i].acf.season_label,
                        tags: data[i].masterclass_season,
                    };

                    t.$data.entries.push( entryData );
                };

                t.$data.displayed_data = t.$data.entries;

                // // Sort display data by date.
                t.$data.displayed_data.sort( (a, b) =>{
                    return t.sortByDate(a,b);
                });
            }
        },
        getSiblings: function( ele ){
            // Setup siblings array and get the first sibling
            var siblings = [];
            var sibling = ele.parentNode.children;

            for (var i = sibling.length - 1; i >= 0; i--) {
                if (i == 1) {
                    siblings.push( sibling[i] );
                }
            };

            return siblings;
        },
        toggleDropdown: function( $event ){
            const t = this;

            $event.target.querySelector('svg').classList.toggle('rotate-00');
            $event.target.querySelector('svg').classList.toggle('-rotate-90');

            let sibiling = t.getSiblings($event.target);

            sibiling[0].classList.toggle('hidden');
        },
        closeDropdown: function( idx ){
            const t = this;

            let dropdown = document.getElementsByClassName('dropdown')[idx];

            if(dropdown){
                dropdown.querySelector('svg').classList.add('rotate-00');
                dropdown.querySelector('svg').classList.remove('-rotate-90');

                let sibiling = t.getSiblings( dropdown );
                sibiling[0].classList.add('hidden');
            }
        },
        sortBy: function( $event ){
            let t = this;
            let target = $event.target;

            let sortByValue = target.dataset.sort;
            let label = target.dataset.label;

            t.$data.displayed_data.sort( (a, b) =>{
                if(sortByValue == "title"){
                    return t.sortByTitle(a,b);
                }

                if(sortByValue == "date"){
                    return t.sortByDate(b,a);
                }

            });

            t.settings.labels.sort_by = label;
            t.settings.sorted = sortByValue;

            t.closeDropdown( 0 );
        },
        sortByTitle: function(a, b){
            console.log('sortByTitle', a, b);

            if (a.title < b.title) {
                return -1;
            }
            if (a.title > b.title) {
                return 1;
            }

            return 0;
        },
        sortByDate: function(a, b){
            if (a.end_date > b.end_date) {
                return -1;
            }
            if (a.end_date < b.end_date) {
                return 1;
            }

            return 0;
        },
        applyTag: function( id ){
            /* --------
            Searches the list of tags for an objects that has
            the same ID as the passed parameter. If a match is
            found - it's pushed to the list of applied tags.
            Lastly, run the list of applied tags through the
            function that looks for and removes duplicates.
            -------- */
            let t = this;
            id = parseInt( id );

            let tag_list = t.$data.tags.list;

            tag_list.some(function(item, index) {

                if( tag_list[index]['id'] === id ){
                    t.$data.tags.applied.push( tag_list[index] );
                    return true;
                }

                return false;
            });

            t.$data.tags.applied = removeDuplicateTags(t.$data.tags.applied, 'id');

        },
        updateResults: function(){
            /* --------
            Loops through all the applied tags. For each tag,
            loop through all the stored entries. If an entry
            has tags, loop through the entries tags and compare
            them to the value of the applied tag. If they match,
            pass the entry to a temporary array.

            Now that we have an array of matching entries,
            create a new Set() which removes any duplicate entries

            That the cleaned results and updated the displayed date.

            Finally, sort the displayed data by date (by default).
            -------- */
            let t = this;

            let tmp_results = [];

            if(t.tags.applied.length > 0){
                for (var i = t.tags.applied.length - 1; i >= 0; i--) {
                    for (var j = t.entries.length - 1; j >= 0; j--) {
                        if(t.entries[j].tags){
                            for (var k =  t.entries[ j ].tags.length - 1; k >= 0; k--) {
                                if(t.tags.applied[i].id == t.entries[j].tags[k].term_id){
                                    tmp_results.push( t.entries[j] );
                                }
                            };
                        }
                    };
                };


                // Create new set, remove duplicates.
                let unique_results = [...new Set(tmp_results)]

                // // Set new display data based on unique results.
                t.$data.displayed_data = unique_results;

                // // Sort display data by date.
                t.$data.displayed_data.sort( (a, b) =>{
                    return t.sortByDate(b,a);
                });
            }
            else{
                t.$data.displayed_data = t.$data.entries;
            }

        },
        filterBy: function( $event ){
            /* --------
            On dropdown button click, get the ID (which is a dataset on the button)
            Pass this ID to the ApplyTag function.
            Update the displayed results.
            Close the dropdown menu.
            -------- */
            let t = this;
            let target = $event.target;
            let id = target.dataset.id;

            t.applyTag( id );
            t.updateResults();
            t.closeDropdown( 1 );
        },
        removeFilter: function($event, id){
            /* --------
            When an X on a tag is clicked, array of applied tags
            and pass the ID to the removeByKey() function which
            loops through the applied tags and removes an object
            if the IDs match
            -------- */
            let t = this;
            let target = $event.target;

            removeByKey(t.tags.applied, {
                key: 'id',
                value: id
            });

            t.updateResults()
        },
         getSrcSet: function( obj ) {
            console.log( obj );
            let scrset_string = '';

            if(obj.sizes.headshot_large) scrset_string += obj.base_path+obj.sizes.headshot_large.file+' 1x';

            if(obj.sizes.headshot_large_xhidpi) scrset_string += ', ' + obj.base_path+obj.sizes.headshot_large_xhidpi.file+' 2x';

            if(obj.full_path) scrset_string += ', ' + obj.full_path+' 3x';

            return scrset_string;
        },
        loadMore: function( $event ){
            console.log( 'loadMore', $event );
        }
    }
}).$mount('#masterclass-app')
